<div style="height: 550px;">
  <form [formGroup]="SettingsForm">
    <div class="mb-3 row">
      <div class="col-lg-12">
        <fieldset>
          <legend>History Settings</legend>
          <div>
            Keep the last &nbsp; <input type="number" pInputText style="width: 70px;" [formControl]="keepCount" /> &nbsp; monitor results.
          </div>

          @if (keepCount.hasError('required')) {
            <div class="alert alert-danger">This value is required</div>
          }

          @if (keepCount.hasError('minValue') || keepCount.hasError('maxValue')) {
            <div class="alert alert-danger">This value must be in the range 0 - 1000</div>
          }

          <div style="margin-top: 10px;">
            Based on the current schedule, results will be stored for: <span style="font-weight: bold;">{{storageEstimate}}</span>
          </div>
        </fieldset>
      </div>
    </div>
  </form>
</div>
